module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/difference-between-vux-template-and-webpack-template-42.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/difference-between-vux-template-and-webpack-template.md
// module id = 744
// module chunks = 446